import type { ActionFunctionArgs, MetaFunction } from 'react-router';
import { Form, Link, redirect, useLoaderData } from 'react-router';
import { prisma } from '~/utils/db.server';

export const meta: MetaFunction = () => {
  return [
    { title: 'Play KQ' },
    { name: 'description', content: 'Killer Queen Arcade Info & Tools' },
  ];
};
export async function loader() {
  const playSessions = await prisma.playSession.findMany();
  return { playSessions };
}
export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const playSession = formData.get('playSession');
  if (!playSession) throw new Error('No playSession provided');

  const session = await prisma.playSession.createNew(playSession.toString());
  console.log(session);
  if (session) {
    return redirect(`/draft/${session.slug}`);
  } else throw new Error('Failed to create session');

  return {
    status: 400,
    message: 'Failed to create session',
  };
}

export default function Index() {
  const data = useLoaderData<typeof loader>();
  return (
    <div className="size-full min-h-svh ">
      <h1 className="text-sm tracking-wide p-4 border-b border-b-slate-800 text-slate-300 uppercase">
        Drafter
      </h1>
      <Form
        className="w-96 max-auto m-8 flex items-center rounded shadow-lg"
        method="post"
      >
        <input
          type="text"
          name="playSession"
          required
          className="h-10 px-3 rounded-l rounded-r-none appearance-none bg-black text-teal-50 border-teal-500 border focus-visible:border-teal-200 outline-none"
        />
        <button
          type="submit"
          className="px-3 py-1 text-sm h-10 bg-teal-500 hover:bg-teal-400 text-black rounded-r appearance-none"
        >
          Start New Session
        </button>
      </Form>
      <ul className="px-8 list-decimal">
        {data?.playSessions?.map((playSession) => (
          <li key={playSession.id}>
            <Link
              to={`/draft/${playSession.slug}`}
              className="text-teal-400 hover:text-teal-600"
            >
              {playSession.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
